import ExpoMixpanelAnalytics from '../custom_modules/mixpanel';
import config from './Config'

const analytics = new ExpoMixpanelAnalytics(config.mixpanel);

export default analytics